import { Map } from 'immutable';

import { getSize } from '@/utils/iterable/getSize';

import { EMPTY } from '@/constants';

function isDragging(state) {
  return !!state.hasIn(['data', 'dnd']);
}

export const dnd = {
  isDragging,
};

function totalProfiles({ shopId, type }) {
  return function select(state) {
    return getSize(state.getIn(['data', 'shopsData', shopId, 'profiles', type, 'byId']));
  };
}

export const profiles = {
  total: totalProfiles,
};

function currentShop(state) {
  return userShops(state).getIn(['byId', currentShopId(state)]);
}

function currentShopId(state) {
  return userShops(state).get('current');
}

function shopsAreLoaded(state) {
  return userShops(state).has('byId');
}

function shopsById(state) {
  return userShops(state).get('byId');
}

function userHasMultipleShops(state) {
  return getSize(userShops(state).get('byId')) > 1;
}

function userHasShops(state) {
  return getSize(userShops(state).get('byId')) > 0;
}

function userShops(state) {
  return state.get('shops');
}

function shopById(shopId) {
  return function select(state) {
    const shop = state.getIn(['shops', 'byId', shopId]);

    if (!shop) return EMPTY.MAP;

    return Map({
      channel: shop.get('channel'),
      channelShopId: shop.get('channelShopId'),
      db: shop.get('db'),
      domain: shop.get('domain'),
      isVelaOnlyShop: shop.get('isVelaOnlyShop'),
      marketplaceId: shop.get('marketplaceId'),
      name: shop.get('name'),
      id: shopId,
      titleFormatPreference: shop.get('titleFormatPreference'),
    });
  };
}

export const shops = {
  currentShop,
  currentShopId,
  shopById,
  shopsAreLoaded,
  shopsById,
  userHasMultipleShops,
  userHasShops,
  userShops,
};
